import * as angular from 'angular';

import { FeatureFlag, FeatureFlagsFacade, Logger } from '@mode/shared/contract-common';
import { ReportDetailsScheduleFacade } from './report-details-schedule.facade';
import { ScheduleModalFacade } from '@mode/shared/schedules/contract';
import template from './schedules-list.html';

const schedulesListDirective = function (
  $log: Logger,
  $q,
  ModeCollection,
  AlertService,
  ReportRunEmailModel,
  ReportSubscriptionModel,
  scheduleModalFacade: ScheduleModalFacade,
  reportDetailsScheduleFacade: ReportDetailsScheduleFacade,
  featureFlagsFacade: FeatureFlagsFacade
) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      reportRun: '<',
      owner: '<',
      schedulesCollection: '=',
      account: '=',
    },
    template: template,
    link: function (scope: angular.IScope, elem, attrs) {
      scope.loading = true;
      featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules).subscribe((flag) => {
        scope.showNamedSchedules = flag;
      });
      featureFlagsFacade.asObservable(FeatureFlag.AdminManagedScheduleIntervals).subscribe((flag) => {
        scope.adminManagedScheduleIntervals = flag;
      });

      function includeSubscriptions(schedules) {
        return Promise.all(
          schedules.map((schedule) =>
            schedule.savedSubscriptions
              ? schedule
              : schedule
                  .reportSubscriptions({ useEntryPath: true })
                  .then(ModeCollection.elements)
                  .then((reportSubscriptions) =>
                    ReportSubscriptionModel.buildSubscriptionWithSlackMembership(reportSubscriptions).then(
                      (subscriptionsWithSlackMemberships) => {
                        schedule.savedSubscriptions = subscriptionsWithSlackMemberships;
                        return schedule;
                      }
                    )
                  )
          )
        );
      }

      scope.isSlackSchedule = function (schedule) {
        return (
          schedule.savedSubscriptions &&
          schedule.savedSubscriptions.length &&
          schedule.savedSubscriptions[0] &&
          schedule.savedSubscriptions[0].savedSlackMemberships &&
          schedule.savedSubscriptions[0].savedSlackMemberships.length
        );
      };

      scope.$watch('schedulesCollection', function (schedulesCollection: any) {
        if (schedulesCollection) {
          schedulesCollection.watch(scope, (schedules) => {
            includeSubscriptions(schedules).then((schedulesWithSubscriptions: any[]) => {
              reportDetailsScheduleFacade.loadRawSchedulesViewDetails(schedulesWithSubscriptions);
              scope.reportDetailsScheduleFacade = reportDetailsScheduleFacade;
              scope.loading = false;
            });
          });
        }
      });

      scope.deleteSchedule = function (schedule) {
        this.schedule
          .destroy()
          .then(() => {
            AlertService.success('Deleted schedule');
          })
          .catch((e) => {
            AlertService.error('Could not delete schedule');
          });
      };

      scope.more = function () {
        if (!scope.schedulesCollection) {
          return;
        }
        scope.loading = true;
        scope.schedulesCollection.next().then(function (schedulesCollection) {
          scope.schedulesCollection = schedulesCollection;
        });
      };

      scope.testEmail = function (subscription) {
        const params = {
          'report_run_email.recipient_address': scope.account.email,
          'report_run_email.message': '',
        };

        const formElements = subscription._new_reportSubscription
          ? subscription._formElements
          : subscription._resource._forms.edit._inputs.report_subscription;
        if (formElements.csv_attachments_enabled) {
          params['report_run_email.csv_attachments_enabled'] = subscription.csv_attachments_enabled;
        }
        if (formElements.pdf_attachments_enabled) {
          params['report_run_email.pdf_attachments_enabled'] = subscription.pdf_attachments_enabled;
        }
        if (formElements.data_previews_enabled) {
          params['report_run_email.data_previews_enabled'] = subscription.data_previews_enabled;
        }
        if (formElements.data_tables_enabled) {
          params['report_run_email.data_tables_enabled'] = subscription.data_tables_enabled;
        }
        if (formElements.report_links_enabled) {
          params['report_run_email.report_links_enabled'] = subscription.report_links_enabled;
        }
        ReportRunEmailModel.create({
          reportRun: scope.reportRun.token,
          report: scope.report.token,
          params: params,
        })
          .then(function () {
            AlertService.success('Email sent');
          })
          .catch(function (e) {
            AlertService.error('Email failed to send');
          });
      };

      scope.canEditSchedule = function (schedule: any) {
        return schedule._resource.hasForm('edit');
      };

      scope.canDestroySchedule = function (schedule: any) {
        return schedule._resource.hasForm('destroy');
      };

      scope.canManageSchedule = function (schedule: any) {
        return scope.canEditSchedule(schedule) || scope.canDestroySchedule(schedule);
      };
    },
  };
};

schedulesListDirective.$inject = [
  '$log',
  '$q',
  'ModeCollection',
  'ToastService',
  'ReportRunEmailModel',
  'ReportSubscriptionModel',
  'ScheduleModalFacade',
  'ReportDetailsScheduleFacade',
  'FeatureFlagsFacade',
];

angular.module('mode.components').directive('modeSchedulesList', schedulesListDirective);
